var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZombie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1248,
    height: 1248,
    viewBox: "0 0 1248 1248",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 936h936V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.867 236.979h597.317V123.388H122.867z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 1248)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(665.783 380.914)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-11.146 0-23.515 8.925-31.51 22.736-5.225 9.031-7.796 18.719-7.236 27.282.539 8.268 3.962 14.629 9.637 17.913.409.237.873.473 1.419.723l1.734.793-.71 1.771c-5.217 13-6.901 24.813-4.397 30.829 2.103 5.056 8.559 12.642 16.827 17.361 6.766 3.506 12.638 5.229 17.879 5.229 2.274 0 4.201-.308 5.9-.58l.803-.126c3.244-.498 11.377-3.396 13.368-4.226 4.304-1.8 7.734-4.967 9.92-9.16l.577-1.107 1.249.032c3.707.098 7.588.164 11.535.199 5.688.051 9.103 2.867 11.078 5.587.45-2.053.69-4.111.356-5.357-1.246-4.637-2.699-8.452-4.317-11.339l-1.668-2.978h12.952l4.887-10.941 5.312 13.407 8.269-2.998 5.561 7.801c.8-4.068 2.558-8.558 4.552-11.613l.066-.096a52.29 52.29 0 001.764-2.541l.041-.061c4.726-7.285 6.889-14.708 5.933-20.375-.706-4.179-3.776-11.269-16.416-11.807l-3.201-.135 1.528-2.817c5.944-10.948 8.322-20.168 6.697-25.962-.882-3.141-2.915-5.52-5.88-6.88-3.919-1.797-8.405-2.749-12.974-2.75-6.993 0-13.591 2.293-18.576 6.457l-1.924 1.607-1.139-2.232c-3.946-7.732-9.414-12.625-16.252-14.542-1.578-.443-3.648-.951-5.667-.951-.321 0-.642.013-.962.04-2.442.207-5.256 1.134-8.366 2.753l-1.818.947-.901-1.841c-1.662-3.396-4.036-6.003-7.056-7.749C6.234.774 3.248 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(669.426 507.55)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-4.475 0-10.373-1.087-18.87-5.492-8.662-4.944-15.412-12.873-17.683-18.329-2.973-7.145-.495-20.173 4.388-32.343a18.697 18.697 0 01-1.589-.811c-12.966-7.503-14.34-28.555-3.129-47.927 8.346-14.419 21.394-23.735 33.24-23.735 3.606 0 6.928.865 9.876 2.572 3.4 1.966 6.04 4.904 7.85 8.6 2.934-1.527 6.111-2.716 9.119-2.972.377-.032.755-.046 1.133-.046 2.064 0 4.149.447 6.207 1.024 7.42 2.081 13.282 7.309 17.492 15.559 5.745-4.798 12.905-6.922 19.859-6.922 4.902.001 9.697 1.046 13.807 2.931 3.516 1.613 5.926 4.434 6.972 8.159 2.306 8.218-2.739 19.857-6.864 27.456 14.381.612 17.594 9.276 18.302 13.471 1.113 6.594-1.522 14.565-6.263 21.85h.001l-.008.011c-.58.89-1.191 1.772-1.831 2.638-3.471 5.321-5.532 13.987-4.338 17.213 0 0-1.778-1.656-3.021-4.835l-5.175-7.261-8.667 3.142-4.278-10.798-3.479 7.79H52.215c1.714 3.059 3.209 6.984 4.503 11.799 1.021 3.805-1.801 11.33-1.801 11.33-.463-1.735-3.116-8.967-11.582-9.042a670.775 670.775 0 01-11.57-.199c-2.369 4.545-6.104 8.065-10.924 10.081-2.107.878-10.363 3.824-13.826 4.356l-.799.125C4.439-.32 2.429 0 0 0m0-4c2.116 0 3.879-.282 5.593-.556l.815-.128c2.951-.453 10.828-3.234 12.89-4.092 3.869-1.618 6.953-4.467 8.92-8.24l1.154-2.215 2.497.066c3.696.096 7.567.163 11.501.197 3.956.035 7.122 1.291 9.555 3.152a2.468 2.468 0 00-.071-.402c-1.203-4.477-2.591-8.139-4.128-10.882l-3.337-5.955H60.457l2.421-5.421 3.873-8.672 3.498 8.83 2.847 7.187 5.015-1.818 2.857-1.035 1.763 2.474 2.209 3.098c.957-2.979 2.269-5.857 3.718-8.079l.065-.099.07-.094a50.95 50.95 0 001.646-2.367l.055-.086c4.481-6.885 6.548-13.81 5.672-19.002-.273-1.614-1.005-3.959-2.948-5.957-2.484-2.554-6.379-3.963-11.58-4.184l-6.404-.273 3.058-5.632c5.694-10.488 8.013-19.177 6.528-24.466-.728-2.595-2.339-4.481-4.788-5.604-3.659-1.679-7.857-2.566-12.139-2.567-6.526 0-12.668 2.128-17.295 5.992l-3.848 3.214-2.278-4.466c-3.682-7.214-8.732-11.765-15.01-13.525-2.161-.607-3.742-.876-5.127-.876-.271 0-.538.01-.794.032-2.145.182-4.777 1.058-7.611 2.534l-3.637 1.894-1.803-3.683c-1.484-3.032-3.591-5.353-6.259-6.898-2.333-1.348-4.981-2.033-7.874-2.033-10.446 0-22.134 8.533-29.778 21.739-5.029 8.69-7.506 17.977-6.973 26.15.496 7.58 3.565 13.372 8.643 16.31.355.206.763.414 1.25.636l3.469 1.587-1.421 3.54c-4.952 12.343-6.682 23.851-4.406 29.317 2.568 6.174 10.094 13.017 15.903 16.352C-10.441-5.638-4.894-4 0-4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(754.21 485.812)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aabf38",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-3.513 4.349-9.227 8.814-18.35 10.236-3.936.615-7.267.814-10.098.748-.597 2.623-1.42 4.83-1.42 4.83s-2.331-24.237-12.38-27.129h17.92l6.751-15.116 5.787 15.67 7.079-3.738L1.886 2.647z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(740.233 481.504)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-4.277-10.798-3.48 7.79h-10.836c1.406 2.51 2.663 5.612 3.784 9.302 2.322.083 5.284-.055 9.05-.643C1.788 4.475 5.954.378 8.155-2.956zm13.977 4.308C10.465 8.656 4.75 13.121-4.372 14.544c-3.937.614-7.268.813-10.099.748a42.221 42.221 0 01-1.42 4.829s-2.331-24.236-12.38-27.129h17.92L-3.6-22.123l5.788 15.67 7.079-3.738 6.596 17.145z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.417 423.875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-6.051-11.947-9.466-25.579-5.653-38.801 1.38-4.787 7.149-1.25 7.519.834 22.607 0 31.333-25.167 49.333-19.667C69.263-52.114 56.921-32 56.921-32 59.268-16.727 3.379 6.671 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.417 423.875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 9,
    d: "M0 0c-6.051-11.947-9.466-25.579-5.653-38.801 1.38-4.787 7.149-1.25 7.519.834 22.607 0 31.333-25.167 49.333-19.667C69.263-52.114 56.921-32 56.921-32 59.268-16.727 3.379 6.671 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(606.674 481.403)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aabf38",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l14.669 21.266c.35 17.322.269 33.501-.033 47.887a3407.315 3407.315 0 01-43.761 7.666c1.678 26.9 2.785 52.318 3.506 75.186-18.45 9.001-47.63 21.346-83.364 30.003l-13.201-14.963c-.045-24.41-.662-49.875-1.721-75.726-34.707 4.757-66.994 8.554-96.841 11.567-2.084 28.814-4.725 57.166-7.898 85.804-15.059-2.459-29.287-6.046-42.408-10.172-.007-.833-.297-1.723-.97-2.62a228.305 228.305 0 00-5.265-6.772c-.07-1.059-.527-2.086-1.518-2.907a411.606 411.606 0 00-3.352-2.749c-3.716-4.041-7.755-7.752-12.333-10.865-2.293-2.467-4.426-5.068-6.291-7.846-4.663-6.945-9.815-13.526-18.473-14.555.706-6.345 1.389-12.867 2.05-19.561-26.907 1.57-52.659 2.859-73.296 3.246l-12.16-20.933c1.59-22.665 4.05-49.668 6.838-77.351 29.736 3.164 58.302 5.343 85.654 6.68a4359.12 4359.12 0 002.916-49.66c-23.145-.723-46.761-2.349-67.996-3.664l-13.367-20.73a8537.508 8537.508 0 016.981-60.156c27.222 2.67 53.216 4.742 78.004 6.297a7809.255 7809.255 0 002.849-82.609c14.771-2.33 51.955-7.8 82.965-9.092 1.314 33.683 2.315 66.122 2.711 96.117 27.701.471 54.917.244 78.82-.472-2.788-28.725-7.207-55.975-9.787-78.761l16.049-11.943c18.025 2.346 39.04 6.748 65.326 15.883 5.671 21.841 10.556 44.912 14.759 68.591 7.441-.716 14.564-1.481 21.428-2.276-.128.535-.24 1.075-.318 1.624-.166 1.164-.055 2.314.336 3.317a224.86 224.86 0 01-3.666 4.989c-1.648 2.179-.865 6.727 1.278 7.982 2.562 1.5 5.717-.765 7.357-2.935.339-.45.669-.906 1.007-1.358 1.082-.023 2.197-.41 3.21-1.298 2.941-2.574 6.289-4.732 9.797-6.6a35.726 35.726 0 001.181 4.561c.003.008.008.015.01.024-.177.311-.347.629-.506.957-1.189 2.452-.692 5.385 1.794 6.841 2.147 1.257 5.436.678 6.714-1.599a5.59 5.59 0 001.142.114c.025 0 .047-.003.071-.004.313 2.196 1.894 4.171 4.762 4.171.114 0 .222-.01.332-.016a757.009 757.009 0 014.962 41.768c-16.721 3.149-33.639 5.892-50.671 8.257a1716.425 1716.425 0 015.07 46.141A972.925 972.925 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(614.75 416)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-3.333-11.667-5.193-5.368C-6.966.635-9.681 9.9-9.681 9.9L1.25 17z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(506.643 493.166)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l21.119-26.264 30.488-14.021-26.233 3.491L0-23.48l-.643-27.937-9 43.25z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.55 514.69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c6.594 3.627 19.934 3.137 19.934 3.137 2.497 4.912 11.66 13.354 19.319 13.948 13.333 1.035 23.493-3.622 31.716-11.997a36.067 36.067 0 006.658-2.82c12.921-7.079 20.717-21.675 18.425-37.101a36.151 36.151 0 00-4.088-12.126c2.597-.037 4.38 1.392 6.84-2.718 9.07-15.151-6.706-38.074-29.324-53.687-14.79-10.214-32.446-6.06-39.282 6.972-19.247.398-37.36 10.492-46.599 28.112C-28.648-44.927-23.383-12.859 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.55 514.69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c6.594 3.627 19.934 3.137 19.934 3.137 2.497 4.912 11.66 13.354 19.319 13.948 13.333 1.035 23.493-3.622 31.716-11.997a36.067 36.067 0 006.658-2.82c12.921-7.079 20.717-21.675 18.425-37.101a36.151 36.151 0 00-4.088-12.126c2.597-.037 4.38 1.392 6.84-2.718 9.07-15.151-6.706-38.074-29.324-53.687-14.79-10.214-32.446-6.06-39.282 6.972-19.247.398-37.36 10.492-46.599 28.112C-28.648-44.927-23.383-12.859 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.618 463.45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.585-.067-1.313-.154-2.165-.141l-7.363.098L-5.98 6.41a31.678 31.678 0 013.588 10.647c1.949 13.115-4.55 26.205-16.173 32.574a31.864 31.864 0 01-5.841 2.472l-1.069.329-.781.796c-7.973 8.124-17.065 11.553-28.219 10.689-5.563-.432-13.61-7.398-15.716-11.545l-1.282-2.517-2.821.102c-3.378.119-13.134-.111-17.645-2.592-21.964-12.08-25.289-41.992-14.614-62.353 7.16-13.657 20.338-22.838 36.151-25.185a53.076 53.076 0 016.624-.559l2.613-.053 1.211-2.313c2.864-5.457 8.172-9.133 14.562-10.083 6.098-.905 12.594.762 18.292 4.697C-4.252-32.71 7.804-12.171.939-.708a6.644 6.644 0 01-.512.757L0 0m-66.459-49.471c-1.756.109-3.513.29-5.243.547l-.001.001c-18.638 2.769-34.196 13.641-42.683 29.829-12.619 24.069-8.325 59.631 18.186 74.21 5.771 3.175 15.048 3.671 19.625 3.708 4.241 5.965 13.291 13.281 21.416 13.911 3.677.285 7.256.175 10.635-.327 8.989-1.335 16.786-5.33 23.799-12.202a40.474 40.474 0 006.409-2.819C.538 49.247 8.848 32.519 6.357 15.758a40.526 40.526 0 00-1.932-7.722C6.743 6.82 8.029 4.672 8.529 3.834c11.197-18.7-8.015-44.003-30.604-59.599-7.55-5.212-16.293-7.402-24.616-6.166-8.316 1.237-15.388 5.727-19.768 12.46"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.691 513.045)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aabf38",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-7.378 2.595-14.814 5.457-22.596 5.817-8.535.394-19.068-2.276-23.053-10.819-2.112-4.526-1.58-10.039-.052-14.662 1.213-3.669 2.612-8.609 5.568-11.309 5.109-4.664 12.95-4.347 19.497-4.324C-18.449-21.575-10.122-9.542 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.691 513.045)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c-7.378 2.595-14.814 5.457-22.596 5.817-8.535.394-19.068-2.276-23.053-10.819-2.112-4.526-1.58-10.039-.052-14.662 1.213-3.669 2.612-8.609 5.568-11.309 5.109-4.664 12.95-4.347 19.497-4.324C-18.449-21.575-10.122-9.542 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.536 451.981)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c6.418-.953 13.175-.412 17.548 4.213 4.666 4.933 11.304 13.313 16.516 20.849 1.249 1.802-5.275 6.312-6.52 4.511-5.009-7.237-11.342-15.24-15.757-19.911-4.678-4.946-22.691.8-28.997 3.921C-15.801 12.882-8.196 1.217 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.082 420.839)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l4.824 9.284S-7.238-.251-17.42 4.136C-27.602 8.522-19.566-.31-19.566-.31l18.355-2.726S-.229-.681 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.81 418.451)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.614.956-1.685 2.472-.664 4.434 1.02 1.963-2.429 1.549-2.429 1.549L-4.956-.349l3.438-2.027z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.49 872.013)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-167.49-87.013-243.99-158.013l-2.5-37 20.5-28.5c69 40.5 161.5 88 223.75 109 0 0 134.25-81.5 186.25-123.5l22.167-3.667 33.333 54C171.698-112.764 10.041-6.566 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.49 872.013)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aabf38",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-167.49-87.013-243.99-158.013l28.211-47.524C-109.279-140.537-25.99-99.657 0-97.734c14.51-4.779 125.242-75.088 206.177-143.946l33.333 54C171.698-112.764 10.041-6.566 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(297 506)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v17c-24.203-1.686-51.82-3.906-74.658-7.845-3.481 32.722-6.201 62.164-7.891 81.362l-12.16-20.933c1.59-22.665 4.05-49.667 6.838-77.35 4.999.532 14.865 1.68 14.855 1.768C-48.914-3.276-22.935-1.16 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(619.62 503.894)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-19.06 3.221-48.745 7.193l-3-21.712c22.268-3.863 37.076-6.747 37.076-6.747z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(303.125 396)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-20.459-1.709-43.863-3.758-64.465-6.671-3.18 19.11-6.19 40.462-8.957 62.26l-13.367-20.73a8604.473 8604.473 0 016.981-60.156c6.171.606 12.271 1.176 18.317 1.721l-.052.283C-47.932-21.914-25.462-20.31 0-18.625z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(386.75 398.375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.046-7.194.094-12.622 0-18.125 25.01.455 58.098 1.561 85.325.694l1.3 18.942C61.876 2.333 28.331.475 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(577.444 382.015)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-1.148 3.203-2.221 6.074-2.569 9.485a87.43 87.43 0 00-.156 1.866L-8.86 3.11c-3.24.124-14.834 10.125-14.834 10.125L-27.161-8.19c8.477-.889 18.549-1.377 28.251-2.077C.958-6.805 1.127-3.142 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.451 596.517)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-12.16-20.933c1.59-22.665 4.05-49.668 6.838-77.35 4.999.532 14.865 1.68 14.855 1.768 24.102 2.722 52.488 1.967 75.423 3.126L83.55-72.017c-24.203-1.686-52.821-3.406-75.659-7.345C4.41-46.64 1.689-19.198 0 0m-2.847-12.864c1.696-18.152 4-40.971 6.76-66.921l.451-4.244 4.206.725c20.508 3.537 45.94 5.282 68.378 6.822l2.874.197.874-13.293c-7.062-.286-14.545-.426-22.391-.574-16.545-.31-33.654-.631-49.221-2.388l-3.965-.448.009-.08a873.87 873.87 0 00-6.873-.798c-2.821 28.277-4.952 52.47-6.339 71.988l5.237 9.014"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(568.375 512.375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.552-22.568c22.269-3.863 39.128-7.179 39.128-7.179L51.245-8.481S29.685-3.972 0 0m3.515-4.516c18.3-2.54 33.177-5.222 40.977-6.711l-9.723-14.094c-5.157.993-17.569 3.353-32.923 6.046L3.515-4.516"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(229.703 451.589)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-13.367-20.729a8598.392 8598.392 0 016.981-60.157c6.171.606 12.271 1.176 18.317 1.721l-.052.283c13.611 1.379 38.796 2.236 64.258 3.922l-.715 20.496c-20.459-1.709-45.863-4.883-66.465-7.796C5.776-43.15 2.767-21.798 0 0m-2.564-11.358c2.538-19.26 5.08-36.562 7.576-51.559l.64-3.85 3.866.546c22.668 3.206 44.974 5.864 62.053 7.407l.433-12.405c-9.343-.59-18.676-1.083-27.03-1.524-13.672-.723-25.48-1.347-33.498-2.159l-4.33-.439.045-.239c-3.451-.316-6.787-.63-10.069-.946a8425.283 8425.283 0 00-6.354 54.827l6.668 10.341"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(472.002 400.365)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a822.066 822.066 0 00-.502-5.115c-.364-3.582-7.794-18.667-7.794-18.667-1.588-15.322-3.572-30.012-5.497-44.262-1.418-10.49-2.756-20.398-3.802-29.632l-.291-2.571 13.232-9.846 6.354-4.729C7.551-73.716 12.002-35.425 15.365-.186z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(482.188 576.813)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.055-2.444-.124-5.045-.204-7.771l14.86-2.078c.932 66.424-2.455 102.686-2.455 102.686L-3.917 74.565l-.003-1.696c-.039-21.508-.535-44.76-1.469-69.189C-3.326 2.117.035 1.539 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485.249 575.658)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.006.246.064 1.662.157 3.961.525 12.966 2.09 51.644 2.212 70.637l6.087 6c.912-13.195 2.359-41.651 1.824-84.057l-.003-.003-.012-1.008L-.05-3.027A283.5 283.5 0 000 0m11.758 89.467L-1.624 76.279C-1.663 54.771-3.964 1.631-3.999.092c-.019-.831-.041-1.693-.062-2.558l-28.962 4.052.05.367-.075.026a5.315 5.315 0 00-1.326-.169c-1.015 0-1.869.249-2.565.666l-.6-4.297 33.368-4.668.444-.062 13.935-1.95 3.991-.558c.027 1.608.048 3.189.068 4.753.808 61.619-2.509 93.773-2.509 93.773"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(470.661 396.491)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l14.133-.529c-3.104-30.38-7.052-63.376-12.071-98.853l-4.881-2.219-9.492 7.064.032.285c1.049 9.256 2.381 19.112 3.794 29.569 1.901 14.075 3.866 28.624 5.45 43.795.229.569.626 1.553 1.113 2.784l2.087 5.279-5.673.19-6.51.22c-20.559.695-43.862 1.484-63.122 1.484-2.121 0-4.17-.009-6.13-.028.019 3.217.003 6.585-.02 10.411 2.6.045 5.256.093 7.955.141 16.66.298 35.543.634 52.351.634C-12.936.227-6.072.153 0 0m-85.315 3.384c.045-7.195.093-12.897 0-18.4 3.229.059 6.636.085 10.175.085 21.237 0 47.304-.959 69.498-1.702a320.189 320.189 0 00-1.313-3.275C-8.543-35.23-10.527-49.92-12.452-64.17c-1.418-10.49-2.756-20.398-3.802-29.632l-.291-2.571 13.232-9.846 9.027 4.103c5.413 38.036 9.625 73.318 12.887 105.78l-45.299.55c-19.424-.078-40.628-.529-58.617-.83"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.392 385.532)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.019 3.217.003 6.585-.021 10.411 2.6.045 5.256.093 7.956.141 16.66.298 35.543.634 52.35.634 8.048 0 14.912-.074 20.985-.227l14.132-.529c-3.103-30.38-7.051-63.376-12.071-98.853l-4.881-2.219-9.492 7.064.032.285c1.049 9.256 2.381 19.112 3.794 29.569 1.901 14.075 3.866 28.624 5.45 43.795.23.569.626 1.553 1.114 2.784l2.087 5.279-5.673.19-6.51.22C48.692-.761 25.39.028 6.13.028 4.009.028 1.96.019 0 0m54.571 15.173c-19.424-.078-40.628-.529-58.617-.83.046-7.195.094-12.897 0-18.4 3.23.059 6.637.085 10.176.085 21.236 0 47.304-.959 69.498-1.702-.772-1.951-1.314-3.275-1.314-3.275-1.587-15.322-3.572-30.012-5.497-44.262-1.418-10.49-2.756-20.398-3.801-29.632l-.291-2.571 13.231-9.846 9.027 4.103c5.413 38.036 9.625 73.318 12.887 105.78z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525.482 646.926)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v-4 4a6.693 6.693 0 01-5.753-3.295l-2.366-4.038a105.997 105.997 0 01-6.809 3.12 6.623 6.623 0 01-2.552.509 6.649 6.649 0 01-6.16-4.112 6.626 6.626 0 01-.004-5.102 6.622 6.622 0 013.607-3.611 89.213 89.213 0 005.155-2.339l-3.464-5.909c-1.856-3.171-.79-7.263 2.378-9.122a6.677 6.677 0 013.371-.917 6.694 6.694 0 015.755 3.297l3.523 6.011c.721-.474 1.443-.959 2.164-1.455l-5.451-6.551a6.616 6.616 0 01-1.515-4.873 6.62 6.62 0 012.374-4.516 6.68 6.68 0 014.263-1.542c1.988 0 3.857.876 5.127 2.404l5.797 6.966c.755-.637 1.505-1.283 2.248-1.937l-7.891-6.406a6.617 6.617 0 01-2.43-4.487 6.623 6.623 0 011.455-4.889A6.641 6.641 0 018-55.26c1.523 0 3.015.529 4.199 1.49l9.153 7.43c2.195-2.333 3.399-3.791 3.416-3.81a6.635 6.635 0 015.159-2.443c1.528 0 3.023.532 4.21 1.499a6.622 6.622 0 012.421 4.492 6.622 6.622 0 01-1.466 4.888c-.164.203-1.312 1.604-3.346 3.812l5.639 4.577a6.673 6.673 0 01.974 9.377 6.637 6.637 0 01-5.177 2.466 6.678 6.678 0 01-4.202-1.493l-6.769-5.494a157.787 157.787 0 01-4.209 3.68l4.75 5.709a6.615 6.615 0 011.515 4.872 6.628 6.628 0 01-2.374 4.517 6.682 6.682 0 01-4.263 1.542 6.648 6.648 0 01-5.127-2.404l-5.074-6.096c-1.324.925-2.654 1.82-3.983 2.681l2.304 3.929A6.667 6.667 0 010 0m0-4a2.668 2.668 0 002.299-4.016l-4.269-7.281a130.445 130.445 0 0010.089-6.775l7.46 8.962a2.659 2.659 0 002.05.961 2.666 2.666 0 002.049-4.372l-7.326-8.804a152 152 0 009.685-8.437l9.466 7.683a2.662 2.662 0 003.751-.389 2.666 2.666 0 00-.39-3.751l-8.999-7.305c3.714-3.786 5.868-6.399 6.127-6.718a2.665 2.665 0 00-2.065-4.351c-.775 0-1.541.335-2.069.981-.064.079-2.274 2.754-6.18 6.689L9.679-50.664A2.657 2.657 0 008-51.26a2.667 2.667 0 00-1.683 4.737l11.508 9.341a150.207 150.207 0 01-8.917 7.721L.566-39.484a2.657 2.657 0 00-2.05-.961 2.666 2.666 0 00-2.048 4.372l8.209 9.864a125.968 125.968 0 01-9.355 6.293l-5.616-9.581a2.664 2.664 0 00-3.649-.952 2.668 2.668 0 00-.952 3.649l5.595 9.545a97.215 97.215 0 01-9.205 4.421 2.667 2.667 0 002.044 4.926 104.49 104.49 0 009.866-4.733l4.292 7.322A2.664 2.664 0 000-4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560.736 620.458)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a2.666 2.666 0 01-3.751.39l-9.466-7.684a151.992 151.992 0 01-9.685 8.438l7.326 8.803a2.666 2.666 0 11-4.099 3.411l-7.46-8.962a130.16 130.16 0 01-10.089 6.775l4.269 7.281a2.667 2.667 0 01-4.602 2.697l-4.292-7.322a104.495 104.495 0 01-9.866 4.734 2.668 2.668 0 01-2.044-4.927 97.215 97.215 0 009.205-4.421l-5.594-9.545a2.667 2.667 0 114.6-2.697l5.616 9.581A125.658 125.658 0 00-30.577.259l-8.209-9.863a2.666 2.666 0 014.098-3.412l8.342 10.023a149.896 149.896 0 008.917-7.72l-11.508-9.342a2.667 2.667 0 013.362-4.141l11.999 9.741c3.906-3.935 6.116-6.61 6.18-6.688a2.664 2.664 0 013.752-.381 2.664 2.664 0 01.382 3.75c-.259.319-2.413 2.933-6.127 6.718L-.39-3.751A2.666 2.666 0 010 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.5 571)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-3.743 11.834-5.75 17-11.25 17.25s-30.5-8-33-16S-56.25-41-53-46.5s8-11.5 12.75-12.125S1.716-63.764 7-47.25C11-34.75 2.102-6.644 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.5 571)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c-3.743 11.834-5.75 17-11.25 17.25s-30.5-8-33-16S-56.25-41-53-46.5s8-11.5 12.75-12.125S1.716-63.764 7-47.25C11-34.75 2.102-6.644 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(554.2 534.169)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-1.283 11.942-3.611 21.45-6.447 24.495-2.835 3.046-28.742 19.461-32.183 15.538-3.442-3.922-14.151-45.989-10.586-54.491 3.565-8.503 8.724-16.464 17.722-16.112C-22.497-30.219 3.372-31.399 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(554.2 534.169)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c-1.283 11.942-3.611 21.45-6.447 24.495-2.835 3.046-28.742 19.461-32.183 15.538-3.442-3.922-14.151-45.989-10.586-54.491 3.565-8.503 8.724-16.464 17.722-16.112C-22.497-30.219 3.372-31.399 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504 441.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3f0f0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-54.25 29.5-147.75 12l10.25 16.75s2.5 22.965 8.5 26.357c6 3.393 67.25 16.393 82.25 15.518s33-5.875 36.25-17.875S0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485.334 491.34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 1.188-.837 2.655-1.859 3.259l-7.282 4.303c-1.022.604-2.076.151-2.341-1.007 0 0-3.478-15.176-1.518-16.728 2.548-2.018 8-3.5 13 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485.334 491.34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M0 0c0 1.188-.837 2.655-1.859 3.259l-7.282 4.303c-1.022.604-2.076.151-2.341-1.007 0 0-3.478-15.176-1.518-16.728 2.548-2.018 8-3.5 13 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485.334 491.34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 1.188-.837 2.655-1.859 3.259l-7.282 4.303c-1.022.604-2.076.151-2.341-1.007 0 0-3.478-15.176-1.518-16.728 2.548-2.018 8-3.5 13 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485.334 491.34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c0 1.188-.837 2.655-1.859 3.259l-7.282 4.303c-1.022.604-2.076.151-2.341-1.007 0 0-3.478-15.176-1.518-16.728 2.548-2.018 8-3.5 13 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465.17 500.347)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.094 1.184-1.139 2.229-2.323 2.321l-8.528.664A2.176 2.176 0 01-13.18 1l-1.481-18.194c-.097-1.184.785-2.004 1.959-1.823l11.897 1.84c1.174.182 2.059 1.299 1.965 2.484z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465.17 500.347)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M0 0c-.094 1.184-1.139 2.229-2.323 2.321l-8.528.664A2.176 2.176 0 01-13.18 1l-1.481-18.194c-.097-1.184.785-2.004 1.959-1.823l11.897 1.84c1.174.182 2.059 1.299 1.965 2.484z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465.17 500.347)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.094 1.184-1.139 2.229-2.323 2.321l-8.528.664A2.176 2.176 0 01-13.18 1l-1.481-18.194c-.097-1.184.785-2.004 1.959-1.823l11.897 1.84c1.174.182 2.059 1.299 1.965 2.484z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465.17 500.347)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c-.094 1.184-1.139 2.229-2.323 2.321l-8.528.664A2.176 2.176 0 01-13.18 1l-1.481-18.194c-.097-1.184.785-2.004 1.959-1.823l11.897 1.84c1.174.182 2.059 1.299 1.965 2.484z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(442.682 500.514)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.1 1.184-1.092 1.812-2.204 1.397l-9.787-3.654c-1.113-.415-2.024-1.727-2.024-2.915v-7.682c0-1.188.968-2.075 2.152-1.971l10.864.955a2.177 2.177 0 011.97 2.342z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(442.682 500.514)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M0 0c-.1 1.184-1.092 1.812-2.204 1.397l-9.787-3.654c-1.113-.415-2.024-1.727-2.024-2.915v-7.682c0-1.188.968-2.075 2.152-1.971l10.864.955a2.177 2.177 0 011.97 2.342z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(442.682 500.514)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.1 1.184-1.092 1.812-2.204 1.397l-9.787-3.654c-1.113-.415-2.024-1.727-2.024-2.915v-7.682c0-1.188.968-2.075 2.152-1.971l10.864.955a2.177 2.177 0 011.97 2.342z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(442.682 500.514)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c-.1 1.184-1.092 1.812-2.204 1.397l-9.787-3.654c-1.113-.415-2.024-1.727-2.024-2.915v-7.682c0-1.188.968-2.075 2.152-1.971l10.864.955a2.177 2.177 0 011.97 2.342z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420.61 496.857)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.151 1.179-1.247 2.143-2.436 2.143h-12.346c-1.189 0-2.409-.94-2.713-2.088l-3.228-12.196c-.303-1.148.399-1.889 1.562-1.646L-.89-9.966C.273-9.723 1.101-8.56.949-7.381z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420.61 496.857)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M0 0c-.151 1.179-1.247 2.143-2.436 2.143h-12.346c-1.189 0-2.409-.94-2.713-2.088l-3.228-12.196c-.303-1.148.399-1.889 1.562-1.646L-.89-9.966C.273-9.723 1.101-8.56.949-7.381z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420.61 496.857)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.151 1.179-1.247 2.143-2.436 2.143h-12.346c-1.189 0-2.409-.94-2.713-2.088l-3.228-12.196c-.303-1.148.399-1.889 1.562-1.646L-.89-9.966C.273-9.723 1.101-8.56.949-7.381z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420.61 496.857)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c-.151 1.179-1.247 2.143-2.436 2.143h-12.346c-1.189 0-2.409-.94-2.713-2.088l-3.228-12.196c-.303-1.148.399-1.889 1.562-1.646L-.89-9.966C.273-9.723 1.101-8.56.949-7.381z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(447.375 773.125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l9.25 3.125 7 22.875h-7L2.959 7-.875 5.25-3.5 3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.667 490.815)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v-14.154c0-1.188-.934-2.431-2.075-2.76l-11.995-3.467c-1.142-.33-2.075.372-2.075 1.56v8.475c0 1.188.081 3.129.181 4.312 0 0 .464 5.515 15.964 6.034"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.667 490.815)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1,
    d: "M0 0v-14.154c0-1.188-.934-2.431-2.075-2.76l-11.995-3.467c-1.142-.33-2.075.372-2.075 1.56v8.475c0 1.188.081 3.129.181 4.312 0 0 .464 5.515 15.964 6.034z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.667 490.815)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v-14.154c0-1.188-.934-2.431-2.075-2.76l-11.995-3.467c-1.142-.33-2.075.372-2.075 1.56v8.475c0 1.188.081 3.129.181 4.312 0 0 .464 5.515 15.964 6.034"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.667 490.815)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0v-14.154c0-1.188-.934-2.431-2.075-2.76l-11.995-3.467c-1.142-.33-2.075.372-2.075 1.56v8.475c0 1.188.081 3.129.181 4.312 0 0 .464 5.515 15.964 6.034z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504 441.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0s-54.25 29.5-147.75 12l10.25 16.75s2.5 22.965 8.5 26.357c6 3.393 67.25 16.393 82.25 15.518s33-5.875 36.25-17.875S0 0 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480.834 452.882)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e5d68c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v6.958c0 1.188-.875 2.584-1.944 3.101l-6.445 3.119c-1.069.516-2.594.218-3.389-.665l-1.611-1.789c-.795-.883-1.445-2.578-1.445-3.766V3.831A201.366 201.366 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480.834 452.882)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0v6.958c0 1.188-.875 2.584-1.944 3.101l-6.445 3.119c-1.069.516-2.594.218-3.389-.665l-1.611-1.789c-.795-.883-1.445-2.578-1.445-3.766V3.831A201.366 201.366 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.206 466.677)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e5d68c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.07 1.186-.83 2.32-2.001 2.52l-2.575.439c-1.171.201-2.903-.225-3.847-.944l-3.564-2.716c-.945-.72-1.538-2.264-1.319-3.432l.625-3.315A237.816 237.816 0 00-.553-9.302z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.206 466.677)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c.07 1.186-.83 2.32-2.001 2.52l-2.575.439c-1.171.201-2.903-.225-3.847-.944l-3.564-2.716c-.945-.72-1.538-2.264-1.319-3.432l.625-3.315A237.816 237.816 0 00-.553-9.302z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(438.856 464.349)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e5d68c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.103 1.183-1.134 2.377-2.289 2.652L-12.754 5.15c-1.155.276-1.939-.457-1.742-1.629l1.162-6.901C-8.555-3.612-3.976-3.958.385-4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(438.856 464.349)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c-.103 1.183-1.134 2.377-2.289 2.652L-12.754 5.15c-1.155.276-1.939-.457-1.742-1.629l1.162-6.901C-8.555-3.612-3.976-3.958.385-4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414.919 459.277)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e5d68c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-.358 3.407c-.125 1.182-.981 2.762-1.904 3.511l-4.646 3.776c-.923.749-2.489.829-3.484.179l-6.053-3.967c-.993-.651-1.807-2.155-1.807-3.343V-.396C-11.905-.062-5.819.059 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(414.919 459.277)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0l-.358 3.407c-.125 1.182-.981 2.762-1.904 3.511l-4.646 3.776c-.923.749-2.489.829-3.484.179l-6.053-3.967c-.993-.651-1.807-2.155-1.807-3.343V-.396C-11.905-.062-5.819.059 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(356.25 588.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f37246",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-5.192.236-27.756-7.104-32.367-14.657-.156-.531-.361-.991-.633-1.343-.518-1.657-1.338-4.45-2.28-7.87-.594-5.949-1.98-14.365.28-22.441C-30.75-61.5-11.75-58 0-53.75c11.74 4.247 13.748 28.176 9.822 40.908C6.905-4.125 4.76-.216 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.48 588.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-4.714.21-25.196-6.341-29.383-13.082-.141-.474-.327-.884-.573-1.199a230.04 230.04 0 01-2.071-7.024c-.538-5.311-1.797-12.823.256-20.031C-27.914-54.893-10.666-51.769 0-47.975c10.658 3.79 12.48 25.149 8.916 36.513C6.268-3.681 4.321-.193 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(356.25 588.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c-5.192.236-27.756-7.104-32.367-14.657-.156-.531-.361-.991-.633-1.343-.518-1.657-1.338-4.45-2.28-7.87-.594-5.949-1.98-14.365.28-22.441C-30.75-61.5-11.75-58 0-53.75c11.74 4.247 13.748 28.176 9.822 40.908C6.905-4.125 4.76-.216 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(549.327 536.508)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f37246",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.3 8.024-1.575 22.156-13.15 30.077l-.001.001c-8.403 5.006-18.543 9.968-20.607 7.616-1.598-1.822-4.763-11.873-7.339-22.966a.04.04 0 01-.003-.015c-.026-.099-.047-.204-.073-.304-.072-.321-.144-.644-.218-.966-2.205-10.629.024-28.941 14.969-32.43C-10.864-22.619-1.301-8.024 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.518 541.002)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.442 7.231-1.164 19.871-12.556 26.773h-.001c-8.282 4.343-18.298 8.614-20.398 6.463-1.627-1.666-4.966-10.752-7.736-20.762a.074.074 0 01-.004-.014c-.028-.089-.05-.184-.077-.275l-.236-.871c-2.392-9.587-.508-25.993 14.324-28.853C-11.244-20.515-1.444-7.232 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(549.327 536.508)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c1.3 8.024-1.575 22.156-13.15 30.077l-.001.001c-8.403 5.006-18.543 9.968-20.607 7.616-1.598-1.822-4.763-11.873-7.339-22.966a.04.04 0 01-.003-.015c-.026-.099-.047-.204-.073-.304-.072-.321-.144-.644-.218-.966-2.205-10.629.024-28.941 14.969-32.43C-10.864-22.619-1.301-8.024 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(351 659.95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f37246",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-5.909-5.844-10.7-13.053-10.7-7.209 0-13.052 4.791-13.052 10.7 0 5.909 5.843 10.7 13.052 10.7S0 5.909 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(329.908 661.566)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f37246",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c2.505-5.352 1.395-11.161-2.479-12.974-3.875-1.813-9.047 1.056-11.551 6.409-2.505 5.352-1.395 11.16 2.48 12.974C-7.676 8.222-2.504 5.353 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(322.633 651.63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f37246",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.29-5.767-2.337-11.486-8.1-12.774-5.763-1.289-11.482 2.341-12.769 8.108-1.291 5.768 2.336 11.487 8.099 12.775C-7.006 9.398-1.288 5.767 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.912 643.056)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f37246",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.727-5.864-5.642-11.482-14.226-12.547-8.585-1.066-16.135 2.825-16.862 8.689-.727 5.865 5.641 11.481 14.227 12.548C-8.277 9.755-.728 5.864 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.36 624.732)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f37246",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.298-10.461-4.609-19.806-13.193-20.87-8.585-1.066-16.598 6.551-17.895 17.013-1.299 10.461 4.608 19.804 13.193 20.871C-9.311 18.079-1.299 10.462 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.162 614.414)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f37246",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.957-7.708-5.228-14.821-13.812-15.885-8.585-1.067-16.32 4.319-17.276 12.027-.957 7.709 5.227 14.82 13.813 15.886C-8.691 13.093-.957 7.708 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(453.75 807.083)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.75-2.833-1.367-1.308L-6 5.333l20.25 2.25z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.503 618.307)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f37246",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l2.75 22.022L18.5 33.614l14.331 6.363 17.333-3.784V15.102L38.497-5.822 7.331-16.64z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.856 656.592)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#82201a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-3.344 3.039-7.744 4.57-10.945 3.815-1.903-.449-3.329-1.673-4.016-3.448-.774-2.001-2.384-6.159-.54-10.182a13.226 13.226 0 01-2.573-.136 29.33 29.33 0 01-3.127 5.878c-3.636 5.24-8.527 8.214-14.142 8.601a1.996 1.996 0 01-2.133-1.858A1.999 1.999 0 01-35.618.538c8.382-.579 12.437-8.515 13.793-11.896-2.485-1.626-3.928-4.418-4.313-8.319-.107.016-.206.039-.315.054-3.316.451-6.086-.328-8.253-2.301-.965-.879-1.725-1.936-2.323-3.068a12.317 12.317 0 01-2.903 3.675c-.548.472-1.141.889-1.767 1.26 1.015 1.808 3.202 4.544 5.405 6.929 2.6-2.206 3.513-4.396 3.576-4.556a2.001 2.001 0 012.576-1.168 2 2 0 011.168 2.576c-.151.402-3.862 9.86-17.823 11.56a2 2 0 11-.484-3.97c3.135-.382 5.617-1.214 7.599-2.217-1.808-1.987-4.398-5.059-5.724-7.649-3.157.797-6.953.733-11.366-.209a2.002 2.002 0 01-1.54-2.374 2.001 2.001 0 012.373-1.538c6.003 1.282 10.634.702 13.399-1.676 2.177-1.873 3.307-4.897 3.371-9.005a21.868 21.868 0 01-.05-2.207 2 2 0 011.979-1.919h.019a2 2 0 011.996 1.879c.046.75.065 1.479.057 2.185.204 2.642.97 6.549 3.161 8.54 1.271 1.152 2.913 1.573 5.019 1.289 3.163-.427 5.331-1.475 6.445-3.117 1.321-1.948.768-4.251.766-4.257a2 2 0 113.863-1.038c.043.162 1.037 4-1.275 7.475-1.133 1.702-2.822 2.985-5.032 3.847.184 3.056 1.094 5.098 2.717 6.077 2.414 1.457 6.281.646 9.189-.394a22.218 22.218 0 013.442-1.502 2 2 0 011.606 3.649c-.35.19-1.651.872-3.455 1.543-1.533.898-2.582 1.946-3.132 3.133-1.017 2.191-.301 4.704.624 7.094.141.366.407.811 1.204.999C-8.429.301-5.309-.58-2.691-2.96A2 2 0 010 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(334.11 639.187)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#82201a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a2 2 0 01-2.111-3.397C-.183-4.6 5.268-8.82 5.03-12.313c-.035-.512-.064-1.008-.094-1.488-.286-4.807-.529-6.825-3.717-8.503-1.933-1.018-6.815-3.185-10.402-1.346-1.982 1.016-3.424 3.171-4.302 6.422-.278 1.944-.646 3.289-.689 3.443a2.005 2.005 0 01-2.334 1.419 2 2 0 01-1.572-2.235c.17-1.219.394-2.359.67-3.421.434-3.28.456-7.779-1.589-10.397-1.323-1.695-3.402-2.481-6.346-2.406-3.821.098-6.353 1.212-7.524 3.308-1.813 3.248-.163 8.328.309 9.145a1.997 1.997 0 01-.557 2.772 2.001 2.001 0 01-2.773-.557c-.268-.404-.678-1.308-1.042-2.51-11.382 1.119-16.423-3.906-16.639-4.13a1.989 1.989 0 01.041-2.803 2.013 2.013 0 012.82.008c.166.163 3.969 3.789 13.046 2.987-.159-2.142.072-4.502 1.167-6.609 1.279-2.462 4.233-5.434 11.049-5.61.162-.004.321-.006.48-.006 4.012 0 7.082 1.33 9.128 3.958 1.243 1.595 1.953 3.513 2.323 5.479a10.22 10.22 0 012.509-1.817c5.065-2.597 11.002-.259 14.09 1.366 5.311 2.795 5.56 6.97 5.848 11.805.028.469.056.954.091 1.454C9.465-6.073.971-.603 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336.947 667.15)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#82201a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-3.039 0-5.89-1.228-7.439-3.205l-3.073-3.92-3.589 3.454c-1.179 1.135-2.324 1.539-3.001 1.539-.219 0-.409-.039-.58-.118-.846-.396-1.346-1.992-1.188-3.793l.539-6.172-6.036 1.396a6.34 6.34 0 01-1.417.163 6.16 6.16 0 01-5.963-4.683l-.856-3.395-3.502-.004c-.8-.001-1.532-.044-2.238-.132-6.34-.787-10.675-4.623-10.314-7.527.071-.575.314-1.12.743-1.667l2.031-2.586-1.847-2.72c-2.089-3.077-2.993-7.214-2.479-11.35.07-.565.179-1.161.341-1.873l.386-1.69-.848-1.512c-.926-1.651-1.298-3.465-1.077-5.244.581-4.685 4.254-9.235 9.741-9.235.533 0 1.978 1.052 2.515 1.119 2.524.312 4.821 1.334 6.645 2.954l4.616 4.1.483-1.094c.992.877 2.03 1.674 2.779 2.83.135.208.282.394.426.585l-.347-.121a4.002 4.002 0 01-5.997.791l-4.616-4.1c-1.216-1.08-2.766-1.763-4.481-1.975a9.032 9.032 0 00-1.12-.071c-3.415 0-6.347 2.068-6.675 4.709-.115.928-.634 4.116 3.519 4.08 2.258-.019 2.656 3.951 1.034 3.999-.794.024-3.802.051-3.875 2.287-.105 3.209 1.938 11.969 6.31 11.596 4.982-.425 1.119 4.142-1.496 4.032-2.292-.097-2.711 1.931-2.566 2.634.649 3.144 9.407 6.181 13.739 4.459 1.701-.676 6.594.281 3.931 2.359-.585.456-2.169 1.249-1.229 3.16 1.85 3.763 9.889 2.923 12.417-.917 1.337-2.032-.789.984-.054 1.623.967.84 3.847-.749 2.386 1.836-1.731 3.062-2.356 5.331-1.292 5.916 1.139.627 4.844-2.724 5.542-1.833 0 0 2.453 3.433 3.372 4.25C0 0 4.553-5.547 4.553-6.2c0-.117-.084-.272-.155-.382l-1.266-1.97c.222.031.441.069.671.069h.584c1.085 0 2.09-.371 2.917-.977l.461.717c.522.814.788 1.67.788 2.543C8.553-2.839 4.636 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.163 655.494)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a6.16 6.16 0 01-5.963-4.683l-.856-3.396-3.502-.004c-.8 0-1.532-.044-2.238-.131-6.339-.788-10.674-4.624-10.314-7.527.071-.576.314-1.12.743-1.667l2.031-2.586-1.847-2.72c-2.089-3.077-2.992-7.214-2.479-11.351.071-.564.179-1.16.341-1.872l.386-1.691-.848-1.512c-.926-1.651-1.298-3.464-1.077-5.243.581-4.685 5.157-8.217 10.645-8.217.533 0 1.075.033 1.611.1 2.524.313 4.821 1.334 6.645 2.954l4.617 4.101 1.22-2.77 25.626 8.895 10.263 18.405v16.298l-4.958 1.082 3.503 5.448c.522.814.788 1.669.788 2.543 0 3.36-3.917 6.2-8.553 6.2-3.039 0-5.889-1.228-7.438-3.205l-3.074-3.92-3.588 3.453c-1.18 1.136-2.325 1.54-3.001 1.54-.22 0-.41-.039-.58-.119-.847-.396-1.347-1.991-1.189-3.793l.539-6.172L1.417-.164C.947-.055.471 0 0 0m-14.978-61.6c-10.022 0-18.438 6.925-19.577 16.108-.387 3.124.085 6.263 1.369 9.175-.067.391-.124.771-.17 1.142-.661 5.32.213 10.537 2.471 14.985a11.946 11.946 0 00-.92 3.342C-32.853-8.392-24.887-.676-13.667.718l.185.022A15.091 15.091 0 00-3.281 8.638c.52.116 1.049.205 1.58.265.846 3.472 2.946 6.23 5.989 7.654 3.091 1.444 6.817 1.228 10.118-.518 3.134 2.308 7.152 3.617 11.378 3.617 9.679 0 17.553-6.819 17.553-15.2 0-.555-.035-1.108-.105-1.658l.772-.168v-25.885L30.933-46.698l-35.78-12.42a21.512 21.512 0 00-7.412-2.313 22.127 22.127 0 00-2.719-.169"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.565 583.227)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aabf38",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-14.9 0-16.817 2.801-16.822 5.24-.004 1.887-3.942 8.256-7.587 13.076l-4.117 5.442 14.399-5.305 5.92 9.184 1.642-2.401v4.199l7.912-3.043 7.834 8.995 4.4-3.482 4.354 4.046v6.412l8.273 1.91h6.499c-3.381 5.503-3.986 13.439-4.017 13.858l-.151 2.142h3.896v12.34l1.835.153c.185.015.371.023.556.023 1.204 0 2.355-.316 3.362-.745-.726 5.485-2.796 13.443-3.723 16.678l-1.1 3.841 25.82-9.824V64.514l-6.044-22.995-4.44-24.991L2.309.033l-.314-.01S1.222 0 .001 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(381 635.666)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-4.075-15.208-5.088-4.659c-.39 4.066-2.958 10.247-6.842 16.662l-1.445 10.614S-31.15 34.455-37.048 36.834h4.715l18.083-3.982 8.772 3.982z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432.667 774.338)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l6.458 10.412 11.209-1.25 3.999 17.166-3.999 7.584 17.666 6.416-8.375-7.666 4-7.875-10.25-19.5L9.333 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.25 819.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-8.5-15.75 7-13-20.996-8.878L-25.5-33.5l12.75 6-12.75 13.25z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.49 872.013)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 9,
    d: "M0 0s-167.49-87.013-243.99-158.013l-2.5-37 20.5-28.5c69 40.5 161.5 88 223.75 109 0 0 134.25-81.5 186.25-123.5l22.167-3.667 33.333 54C171.698-112.764 10.041-6.566 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.667 772.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-1.666.5-12.042 2.833-10.209-10.716v-2.45l8.5 4.833z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(516.75 731.625)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l13.875 1.375V16.5L21 12.836V5.5l-3.625-8.625-8.125-2.25-7.375 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(333.25 801.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-6.506 8.927-10.077-6.177 3.167-5.167 9.667-7.608-8.334-3.225-3.166-15.667-10.667-1L-37.5-36.8v-26.95l2.846 20.324 11.404 7.676h13l4.754 16.122L8.5-12z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.49 872.013)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-167.49-87.013-243.99-158.013l28.211-47.524C-109.279-140.537-25.99-99.657 0-97.734c14.51-4.779 125.242-75.088 206.177-143.946l33.333 54C171.698-112.764 10.041-6.566 0 0m-.227-4.636c9.995-6.576 49.987-33.126 95.955-66.8 62.86-46.049 110.756-86.332 138.792-116.713l-29.306-47.475c-46.39 39.08-97.849 75.043-124.794 93.26C43.061-117.106 9.766-96.739 1.251-93.935l-.754.248-.792-.058c-27.343-2.023-111.168-43.651-214.11-106.271l-24.489 41.254C-167.296-93.6-19.483-14.784-.227-4.636"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.667 420.833)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l6.137-14.583V6L12 12.834l-.33 13L8.954 17 1 6.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335.334 454.206)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l11.333 27.099L9.342 3.742z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.667 481.305)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-1.166-27.099-8.164-6.858v-8.598l-8.41-11 2.877-21.5-9.228 17.256 7.679 18.244-1.107 12.456 12.186 4.675z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(287.768 564.832)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-3 11.918s-11.892 12.953-27.402 13.669c-15.511.717 11.884 4.706 11.884 4.706L0 27.668l2.482-7.75v-5.375l2.75-5.625V4.793z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(577.75 373.375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.312 1.344 1.762 3.563-1.791 3.652a1110.95 1110.95 0 01-20.516 2.166l-4.135.398-.726-4.091c-4.188-23.6-8.923-45.76-14.081-65.91-21.306-7.271-40.595-11.951-60.354-14.648l-12.5 9.303c.987 8.408 2.202 17.402 3.481 26.871 2.136 15.813 4.345 32.163 6.017 49.394l.464 4.788-4.808.144c-15.979.479-32.682.721-49.646.721a1729.9 1729.9 0 01-29.385-.248l-4.367-.074-.057-4.365c-.342-25.95-1.171-55.91-2.532-91.465-27.473 1.463-58.683 5.861-74.256 8.252a7779.729 7779.729 0 01-2.741 78.917l-.183 4.599-4.594-.288c-24.046-1.508-48.843-3.486-73.776-5.884a8457.692 8457.692 0 00-6.277 54.162l11.265 17.469c2.564.16 5.161.325 7.786.49 18.84 1.189 38.321 2.419 57.802 3.028l4.598.143-.246 4.594a4357.892 4357.892 0 01-2.919 49.711l-.286 4.42-4.423-.216c-26.697-1.305-54.062-3.399-81.408-6.227-2.79 27.992-4.9 51.963-6.279 71.34l10.134 17.443c17.344-.38 39.857-1.399 70.474-3.185l3.463-.202c-.535.728-.889 1.644-.948 2.756-.098 1.851-3.012 4.419-3.973 6.039-1.345 2.27-2.621 4.58-3.927 6.872.216-2.037.431-4.087.644-6.176-29.609 1.693-51.383 2.634-68.209 2.949l-2.645.049-14.185-24.417.097-1.38c1.454-20.721 3.758-46.792 6.849-77.486l.454-4.503 4.5.479c27.166 2.89 54.38 5.053 80.971 6.436a4357.34 4357.34 0 002.383-40.598c-18.076-.652-36.055-1.787-53.488-2.886-3.399-.215-6.751-.427-10.046-.631l-2.271-.14-15.469-23.99.179-1.593A8489.046 8489.046 0 01-358.9-3.206l.522-4.374 4.385.43a2246.24 2246.24 0 0073.251 5.991 7863.58 7863.58 0 002.664-77.956l.109-3.732 3.688-.582c14.674-2.314 52.181-7.839 83.478-9.142l4.508-.188.177 4.508c1.39 35.627 2.26 65.739 2.651 91.861 8.219.118 16.565.178 24.872.178 15.174 0 30.135-.194 44.551-.58-1.588-15.322-3.572-30.012-5.497-44.262-1.418-10.49-2.756-20.398-3.802-29.631l-.291-2.572 19.586-14.575 1.807.235c21.719 2.827 42.762 7.942 66.222 16.094l2.274.79.604 2.33c5.15 19.832 9.889 41.628 14.099 64.838C-12.863-4.162-6.731-4.83-.668-5.539-1.231-3.651.445-1.923 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624.086 551.876)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-.077 3.675-3.617.658a3456.091 3456.091 0 01-39.825 7.001 2473.687 2473.687 0 013.263 71.282l.092 2.909-2.617 1.277c-18.414 8.984-47.984 21.539-84.278 30.332l-2.638.639-16.118-18.271-.003-1.696c-.04-21.926-.552-45.657-1.521-70.608-29.961 4.055-59.633 7.594-88.33 10.535-1.995 26.943-4.498 53.876-7.637 82.205l-.521 4.709-4.677-.764c-7.675-1.253-15.415-2.858-23.203-4.776.149-.055.299-.109.45-.162 3.635-1.271 7.365-2.229 11-3.5 1.357-.474 2.274-1.33 2.818-2.345 1.907.386 3.81.753 5.71 1.096 3.026-27.796 5.438-54.305 7.36-80.882l.272-3.772 3.764-.38c31.318-3.163 64.5-7.032 97.335-11.533 0 0 4.157 55.353 4.225 78.37l12.226 11.741c32.649-8.15 59.538-19.315 77.201-27.762a2445.692 2445.692 0 00-3.405-72.126l-.252-4.045 3.996-.673a3395.407 3395.407 0 0040.08-7c.258-14.341.254-28.674-.011-42.675l-12.198-17.682a987.597 987.597 0 01-31.867 6.153l-4.792.843-.468-4.842a1711.776 1711.776 0 00-5.055-46.02l-.546-4.401 4.392-.61a1073.197 1073.197 0 0046.427-7.471 763.594 763.594 0 00-3.16-27.567c.987-.333 1.896-1.037 2.562-2.215 1.001-1.773 1.77-3.666 2.758-5.446.264-.475.526-.956.824-1.411.001-.002.539-.681.611-.81.252-.217.666-.571.47-.484a8.49 8.49 0 01.395-.222c1.952 13.328 3.595 27.233 4.885 41.419l.37 4.073-4.019.756a1070.824 1070.824 0 01-46.5 7.675 1719.988 1719.988 0 014.07 37.014 973.087 973.087 0 0029.704-5.859l2.938-.628L.006-49.424l.027 1.351A1169.52 1169.52 0 010 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.856 593.484)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c2.644-3.671 3.039-8.683 3.039-8.683l-1.196-6.301 5.551-7.125-17.5-16.75 11 16-4.375 9s4.5 6.125-4.114 18.377C-12.669 11.734-1.606.266-1.606.266S-.237.33 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552.125 759.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-.625 8s10.25-22.875 5.75-41.5L2.375-32 .625 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.5 767.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-3-28.25-15.168 7L-19.5-36.5l-11.75-1.75.258-3.313a19.027 19.027 0 002.245-1.935 27.115 27.115 0 003.731-1.425c.008.058.008.115.016.173L-11.5-43v11.75L3-40S6-14.5 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(503.674 406.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c2.172.25 6.061 9.75-.258 12.25 0 0 2.673 2.32 0 7.16C-2.932 24.25 3.19 23.25-1.886 30c0 0-20.411 25.259-85.455 20.456-.617-4.224-.087-9.206 5.332-9.617C-67.869 39.766-71.4 31.632-61.427 31c9.974-.632 9.76 6.178 14.565 5.839 4.804-.339 7.227-4.966 6.889-10.589-.701-11.666 11.632-20.666 16.6-14.5 0 0-.944-8.75 1-11.5 1.943-2.75 6.076-7.457 11.422-4.853 0 0 2.213-1.302 2.213-3.647 0-2.345-3.225-8.328-.065-8.328 0 0-.203-7.422 5.143-7.422C6.493-24 4.403-13.045 3.189-6.045 1.974.955-2.171-.25 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.94 411.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c2.234.25 6.234 9.75-.266 12.25 0 0 2.75 2.32 0 7.16S3.28 23.25-1.94 30c0 0-18.665 22.315-85.577 17.512-.634-4.224-.146-7.673 3.154-7.673 14.588 0 10.914-9.207 21.173-9.839 10.26-.632 10.04 6.178 14.982 5.839 4.942-.339 9.192-6.089 7.942-11.589s7.5-21 17.25-13.5c0 0-2-7.75 0-10.5s6.25-7.457 11.75-4.853c0 0 .262-6.302.262-8.647 0-2.345.488-5 3.738-5 0 0-2-5.75 3.5-5.75s4.25 9.5 3 16.5S-2.234-.25 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.94 411.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c2.234.25 6.234 9.75-.266 12.25 0 0 2.75 2.32 0 7.16S3.28 23.25-1.94 30c0 0-18.665 22.315-85.577 17.512-.634-4.224-.146-7.673 3.154-7.673 14.588 0 10.914-9.207 21.173-9.839 10.26-.632 10.04 6.178 14.982 5.839 4.942-.339 9.192-6.089 7.942-11.589s7.5-21 17.25-13.5c0 0-2-7.75 0-10.5s6.25-7.457 11.75-4.853c0 0 .262-6.302.262-8.647 0-2.345.488-5 3.738-5 0 0-2-5.75 3.5-5.75s4.25 9.5 3 16.5S-2.234-.25 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(519.004 446)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a3.497 3.497 0 00-3.488 3.825l3.25 34.805a3.499 3.499 0 106.968-.651L3.48 3.175A3.498 3.498 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(532.401 450.348)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a3.5 3.5 0 00-3.425 4.24l4 18.5a3.5 3.5 0 006.842-1.479l-4-18.499A3.5 3.5 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(545.12 450.348)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a3.5 3.5 0 00-3.28 4.722l2.5 6.716a3.5 3.5 0 006.56-2.442L3.28 2.28A3.5 3.5 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(519.004 446)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0a3.497 3.497 0 00-3.488 3.825l3.25 34.805a3.499 3.499 0 106.968-.651L3.48 3.175A3.498 3.498 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(532.401 450.348)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0a3.5 3.5 0 00-3.425 4.24l4 18.5a3.5 3.5 0 006.842-1.479l-4-18.499A3.5 3.5 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(545.12 450.348)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0a3.5 3.5 0 00-3.28 4.722l2.5 6.716a3.5 3.5 0 006.56-2.442L3.28 2.28A3.5 3.5 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(574.719 393.365)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l1.553-21.438s-18.087-4.908-17.438-.594c1.116 7.417-5.084 23.917-5.084 23.917l-3.999-24.375 31.54-3.536-3.906 24.47z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(622.509 393.509)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-5.216 8.274-9.598 17.532-9.376 19.812.045.366.049.729.024 1.087a39.04 39.04 0 00-2.934-1.075 34.45 34.45 0 01-1.071-.357c.002-.001-.005-.005-.007-.007.293-6.23 9.98-21.594 9.98-21.594l-12.375 4.119v-5.744l-9 6.5-1.625-15.375L-47.79-.144l.305-4.21 19.006-11.687 5.406-3.324.667 6.311.9 8.512 3.405-2.46 6.342-4.58v8.021l7.112-2.368 10.61-3.532z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(609.52 410.748)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aabf38",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.499 1.671-1.167 3.517-1.872 5.317-3.711 2.12-12.899 2.185-12.899 2.185l-22.25-4.75-11.25-3.25-19.63-1.25-1.721-15.375 13.851 1.625 22.25-2 20.125-12.375 1.625 15.375 9-6.5v5.744l12.375-4.119S1.834-7.05 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(342.807 611.781)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636f2f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l3.703 5.344c.115 2-.687 7.456-4.661 7.915-3.974.46 1.298 2.242 1.298 2.242l4.853-1.907L7.568 3.469z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372.356 666.072)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-6.185 2.254-20.796 7.912-7.468 2.841 2.199-7.681c1.01-3.524 2.369-8.941 3.189-13.427a9.274 9.274 0 01-.904.045h-.002c-.24 0-.48-.01-.721-.03l-3.668-.306v-12.18H-38.4l.303-4.284c.01-.137.251-3.41 1.242-7.223a32.613 32.613 0 011.498-4.493h-3.455l-6.944-1.603-3.1-.715v-7.132l-2.459-2.285-1.56 1.234-2.992 2.367-2.506-2.877-5.661-6.501-3.887 1.495-5.435 2.091v-1.573l-2.956-4.584-3.419-5.306-6.493 2.392-12.797 4.715 8.224-10.881c3.294-4.359 6.358-9.359 7.045-11.424 1.517.155 2.79-.338 3.743-1.176.135.16.282.308.44.448a1.14 1.14 0 00-.045.287c-.008 3.722-7.992 14.278-7.992 14.278l9.5-3.5 5.157 8 3.593-5.25v7.75l6.5-2.5 7.5 8.612 4.25-3.362 6.25 5.806v5.694l6.5 1.5 12.812-.75 2.175-8.539-6.181-4.43 4.977-2.656-2.839 2.54 6.799 2.731-.368 11.166-9.808 3.665c-2.807 5.103-3.317 12.273-3.317 12.273h3.75v12.5c.13.01.26.016.39.016 2.864-.001 5.61-2.516 5.61-2.516.25 6-4.048 21-4.048 21l20.798-7.913z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760.661 450.243)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-1.087-6.444-9.854-6.569-17.021-5.539l-10.036 1.44 5.665-8.41c4.879-7.245 11.954-21.114 10.163-27.487-.331-1.178-.947-1.898-2.058-2.407-5.84-2.678-13.558-3.042-19.976.03-2.963.837-5.656 2.524-7.97 4.603-1.249 1.123-2.281 2.51-3.645 3.494l-.383.278a1.62 1.62 0 01-.47.343c-3.171-7.932-11.622-18.205-17.371-19.824-11.683-3.297-25.851 6.65-28.543 8.655 0 0 1.327-5.947 6.857-10.34-1.049-2.603-2.636-4.597-4.722-5.805-1.56-.902-3.366-1.36-5.368-1.36-8.427 0-18.892 7.913-25.451 19.242-8.394 14.504-7.749 31.397.562 36.206 3.359 1.374 8.442-.226 10.941-1.188-7.892 12.892-13.367 31.577-10.653 38.096 2.05 4.926 8.297 12.911 18.902 16.646.804.283 11.05 1.826 14.171 1.328l.848-.135c2.143-.328 9.419-2.797 11.765-3.777 5.349-2.235 8.417-7.529 8.417-14.528 0-8.677-7.058-15.736-15.737-15.736h-.002c-3.9 0-7.641 1.437-10.533 4.047a4.41 4.41 0 01-6.224-.319 4.41 4.41 0 01.319-6.224 24.497 24.497 0 0116.438-6.317h.002c13.538 0 24.55 11.012 24.55 24.549 0 1.246-.078 2.459-.218 3.641 2.468.055 5.509.108 8.96.138 2.95.026 5.518.614 7.76 1.559-1.893-5.007-4.659-9.501-8.637-10.646h17.92l6.751-15.115 5.787 15.67 7.079-3.739 3.511 9.126c-.027-4.041 1.258-10.799 2.336-12.607C-1.243 10.757.798 4.725 0 0m2.611 20.353h.001l-.007.01a54.15 54.15 0 01-1.832 2.639c-3.47 5.32-5.532 13.986-4.337 17.213 0 0-1.779-1.656-3.021-4.835l-5.176-7.261-8.667 3.142-4.277-10.798-3.479 7.79H-39.02c1.713 3.058 3.209 6.983 4.503 11.799 1.021 3.804-1.801 11.33-1.801 11.33-.463-1.736-3.116-8.967-11.582-9.042a670.923 670.923 0 01-11.571-.199c-2.369 4.545-6.103 8.065-10.923 10.081-2.107.878-10.364 3.824-13.827 4.355l-.798.126c-5.053.808-11.977 1.908-25.086-4.888-8.662-4.943-15.412-12.873-17.683-18.329-2.974-7.144-.495-20.173 4.388-32.343a18.54 18.54 0 01-1.589-.81c-12.966-7.503-14.34-28.556-3.129-47.928 8.346-14.419 21.393-23.734 33.24-23.734 3.606 0 6.928.865 9.876 2.571 3.4 1.967 6.04 4.904 7.85 8.601 2.933-1.528 6.111-2.716 9.119-2.972 2.431-.207 4.905.295 7.34.978 7.42 2.081 13.282 7.308 17.492 15.558 5.745-4.798 12.904-6.922 19.858-6.922 4.903.001 9.698 1.046 13.808 2.932 3.516 1.612 5.926 4.433 6.972 8.158 2.305 8.219-2.74 19.858-6.865 27.456C4.953-14.357 8.167-5.692 8.875-1.497c1.112 6.594-1.522 14.564-6.264 21.85"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(707.767 446.462)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.404 1.7 1.515 2.748 2.901 3.281L.764 12.032 12.376 1.288S4.196 2.913 3.893-.924c-.152-1.917.271-7.168.745-10.673.19-1.411.363-2.688.461-3.666C5.099-15.263-.57-2.403 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163.375 472.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-4.25 5.345-13.125 2.25-13.125 2.25C-11.875 13 .375 24.167.375 24.167L-6.34 27.75l12.161 7.564c-.553 2.063.304 18.436.304 18.436 2.696-2.693 8.75-5.25 8.75-5.25l5.5 8.061s1-18.061 3.75-22.561"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.096 516.387)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.234.25-.461.521-.663.84-.942 1.487-2.083 2.678-3.177 3.839-.175-4.227-.33-9.466-.176-12.213l-14.045-8.736 7.374-3.934c-3.661-3.792-11.131-12.485-12.145-21.201l-.363-3.155 3.004 1.034c.077.025 10.41 2.232 13.715-1.926-2.463 6.801-8.339 6.999-11.774 6.471 2.682 8.959 12.146 17.687 12.252 17.784l2.091 1.909-6.154 3.284 9.218 5.732 1.186.819L.036-8.07C-.13-7.323-.117-4.089 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.294 504.872)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-1.245 2.508-3.865 15.316-5.081 24.763l-1.511 11.738-9.986-14.638c-1.59.855-3.183 1.846-4.035 2.698L-27.76 31.7s1.627-25.474 1.546-27.72l4.359-1.919 1.171 13.256 4.578-4.752 3.75 3.313c1.002-5.777 2.239-13.993 3.748-16.67 1.451-2.574 3.927-2.843 6.135-1.7C-.267-3.349 1.63-3.283 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(605.09 205.355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aabf38",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c4.17 3.581 6.354 8.327 5.336 12.925-1.623 7.329-10.753 11.594-20.771 9.944-6.042 5.407-17.934 7.516-30.639 4.704-16.89-3.738-28.817-14.751-26.638-24.597.854-3.858-.728-21.449.789-28.309 2.581-11.661 17.022-18.382 32.255-15.011 10.894 2.41 19.238 9.328 22.168 17.338 1.156.1 2.329.266 3.512.527C-3.41-20.138 3.786-12.011 2.086-4.325 1.732-2.725 1.002-1.279 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(605.09 205.355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c4.17 3.581 6.354 8.327 5.336 12.925-1.623 7.329-10.753 11.594-20.771 9.944-6.042 5.407-17.934 7.516-30.639 4.704-16.89-3.738-28.817-14.751-26.638-24.597.854-3.858-.728-21.449.789-28.309 2.581-11.661 17.022-18.382 32.255-15.011 10.894 2.41 19.238 9.328 22.168 17.338 1.156.1 2.329.266 3.512.527C-3.41-20.138 3.786-12.011 2.086-4.325 1.732-2.725 1.002-1.279 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468 243.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-13.768-9.75-13.884-24.25C-14-38.75-8.5-54.75 11.75-57s22.75 1.5 22.75 1.5S30-74.75 61-79.75c0 0 10-1.5 16-4.5l-2.75 12.5L83-60.5s-8.625 6.625-12.25 11c-2.841 3.429-2 15.75-2 15.75l24.157-9.089 2.5 18.5L119-25.75S107.75-15.5 106.25-12.5c0 0 12 5 15.75 20.5L98.25-3.75S83-1.25 75.5-4.75c0 0-13.25 17.928-18.75 17.839C51.25 13 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468 243.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0s-13.768-9.75-13.884-24.25C-14-38.75-8.5-54.75 11.75-57s22.75 1.5 22.75 1.5S30-74.75 61-79.75c0 0 10-1.5 16-4.5l-2.75 12.5L83-60.5s-8.625 6.625-12.25 11c-2.841 3.429-2 15.75-2 15.75l24.157-9.089 2.5 18.5L119-25.75S107.75-15.5 106.25-12.5c0 0 12 5 15.75 20.5L98.25-3.75S83-1.25 75.5-4.75c0 0-13.25 17.928-18.75 17.839C51.25 13 0 0 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(532.625 254.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.655 2.736-.152 6.504-1 9.25-2.625 8.5-19.324 11.742-39.613 9.07C-60.9 15.648-74 9.25-75.745 1.323c-.847-3.846-.509-7.471 1.245-11.823 3.375-8.375 18.591-13.812 38.879-11.14C-15.335-18.968-2.091-8.734 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(533.536 264.34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-2.236 7.241-12.547 11.394-28.287 11.394-4.271 0-8.812-.314-13.498-.931C-63.214 7.642-76.636.88-78.609-8.087c-.952-4.324-.538-8.334 1.342-13 3.251-8.067 8.037-12.128 23.668-12.128 0 0-16.494 3.049-19.957 13.623-1.317 4.023-1.925 7.11-1.147 10.646 1.544 7.012 14.357 12.93 33.439 15.444 4.515.594 8.88.896 12.977.896 13.457 0 22.832-3.286 24.465-8.574 1.048-3.395 1.302-6.361.966-8.194-1.9-10.371-10.092-16.554-10.092-16.554 7.86 4.553 12.719 10.342 13.982 15.622C1.81-7.068.899-2.914 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(516.862 263.476)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.355-2.706-9.865-6.285-22.829-7.992C-35.795-9.7-46.595-8.89-46.95-6.185c-.357 2.707 9.864 6.287 22.829 7.994C-11.155 3.517-.356 2.706 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(516.862 263.476)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c.355-2.706-9.865-6.285-22.829-7.992C-35.795-9.7-46.595-8.89-46.95-6.185c-.357 2.707 9.864 6.287 22.829 7.994C-11.155 3.517-.356 2.706 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(581.448 197.01)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-12.948.739-18.448-7.178l6.833-10.834L5.976-5.922z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(581.448 197.01)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0s-12.948.739-18.448-7.178l6.833-10.834L5.976-5.922z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(594.531 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-6-7.875 7.709-5L9.219-1.5S4.5 1.125 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(594.531 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0l-6-7.875 7.709-5L9.219-1.5S4.5 1.125 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(602.125 229.125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-.792-8H-11l-1.471 6.709S-6.235 1 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(602.125 229.125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0l-.792-8H-11l-1.471 6.709S-6.235 1 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(586.667 188.833)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0s2.166-2.5 0-8.62"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(591.866 207.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-5.201 5.226 6.719-2.188z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(574.893 196.504)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-4.643 8.746 9.286-6.689z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.72 282.733)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-4.574 0-9.423-.333-14.412-.99-24.882-3.278-40.063-11.795-42.747-23.985-1.256-5.709-.72-11.149 1.687-17.123.343-.851.746-1.678 1.21-2.481-3.188-5.007-5.811-11.379-5.871-18.832-.19-23.792 12.385-39.405 33.64-41.768 4.623-.513 8.782-.773 12.365-.773 1.14 0 2.361.02 3.619.088a26.462 26.462 0 013.017-6.021c5.574-8.314 15.604-13.692 29.809-15.983l.05-.008.049-.008c3.332-.506 9.899-1.944 13.31-3.649l16.868-8.434-2.74 12.446a43.129 43.129 0 012.471-.071c3.254 0 6.549.365 9.793 1.082 11.975 2.65 23.437 15.059 25.954 17.927 15.51 3.554 25.442 16.167 22.642 28.823-.065.293-.137.585-.215.875 3.415 5.014 4.697 10.807 3.465 16.376-1.042 4.706-3.766 8.806-7.753 11.843l.456 4.603-8.365 1.341a30.08 30.08 0 01-4.741.367c-1.61 0-3.149-.122-4.548-.301 1.839 3.174 3.424 6.917 4.486 11.306l4.531 18.728-17.27-8.545L59.469-33.7c-2.364.272-5.875.582-9.617.582-3.043 0-5.772-.197-8.215-.596a130.747 130.747 0 01-5.104 5.903c.295 3.32-.225 7.168-1.557 11.482C31.724-5.799 19.303 0 0 0m-.001-9c13.957 0 24.353-3.429 26.377-9.983.848-2.746 1.655-6.514 1-9.25a13.17 13.17 0 00-.793-2.289c5.62-5.282 11.668-13.461 11.668-13.461 3.089 1.441 7.49 1.865 11.601 1.865 5.872 0 11.149-.865 11.149-.865l23.75 11.75c-2.346-9.695-7.918-15.282-11.763-18.107 4.699-.941 8.667-2.709 11.417-5.17.746.123 1.486.203 2.219.262 1.696.421 4.201.893 6.937.893 1.081 0 2.198-.074 3.315-.253l-.195-1.974c4.384-1.694 7.596-4.81 8.496-8.872 1.017-4.598-1.166-9.344-5.336-12.925 1.002-1.279 1.731-2.725 2.086-4.325 1.7-7.686-5.496-15.813-16.075-18.153a26.905 26.905 0 00-3.511-.528 21.21 21.21 0 00-.895-2.05c-.01-.029-.017-.055-.028-.085 0 0-11.32-13.006-21.245-15.203a36.389 36.389 0 00-7.848-.869c-5.348 0-10.33 1.232-14.407 3.439l1.833-8.33c-6 3-16 4.5-16 4.5-31 5-26.5 24.25-26.5 24.25s-1.478-2.219-11.379-2.219c-2.97 0-6.699.199-11.371.719-20.25 2.25-25.75 18.25-25.634 32.75.067 8.282 4.585 15.009 8.449 19.26-2.107 1.61-3.624 3.462-4.44 5.49-1.754 4.351-2.092 7.977-1.245 11.823 1.745 7.927 14.845 14.325 35.132 16.997C-8.595-9.302-4.142-9-.001-9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.106 518.906)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff097",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-14.676 1.684 1.071-16.384 6.71.091S3.135-7.394 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.106 518.906)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0l-14.676 1.684 1.071-16.384 6.71.091S3.135-7.394 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.332 232)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c7.667-9.334 15.779-23.666 5.557-33 0 0 16.776-39.609-12.89-54.75-29.666-15.141-75.001-13.917-96.667 10.083-21.666 24 6.015 62.023 27.508 62.012 0 0 9.902 22.449 26.364 20.719C-33.666 3.333 0 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.332 232)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c7.667-9.334 15.779-23.666 5.557-33 0 0 16.776-39.609-12.89-54.75-29.666-15.141-75.001-13.917-96.667 10.083-21.666 24 6.015 62.023 27.508 62.012 0 0 9.902 22.449 26.364 20.719C-33.666 3.333 0 0 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(386.374 231.744)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.234 2.479 1.403 6.327 1.294 9.198-.339 8.889-14.525 16.291-33.327 18.893-18.8 2.6-32.045-.237-35.484-7.455-1.668-3.502-2.224-7.094-1.683-11.749 1.04-8.959 13.378-18.105 32.179-20.705C-18.223-14.419-3.939-7.91 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.667 241.019)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.372 9.739-14.13 17.902-35.052 20.798-4.637.64-9.019.966-13.026.966-12.892 0-21.606-3.389-24.537-9.542-1.867-3.916-2.442-7.877-1.864-12.84.673-5.808 5.144-11.196 12.109-15.314-.076.278-7.801 6.293-8.137 15.775-.15 4.255-.042 7.417 1.503 10.658 2.199 4.616 9.826 7.263 20.926 7.263 3.824 0 8.022-.313 12.477-.929C-17.277 14.3-4.282 7.314-3.998-.152a24.93 24.93 0 00-1.085-8.231c-2.634-8.644-14.778-13.876-14.778-13.876 8.714 2.111 15.55 6.453 18.358 12.093C-.052-7.253.115-3.03 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.856 244.384)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.322-2.707-10.322-3.556-22.336-1.894C-34.351-.232-43.83 3.313-43.509 6.018c.322 2.709 10.322 3.557 22.337 1.894C-9.157 6.25.321 2.707 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.856 244.384)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 4,
    d: "M0 0c-.322-2.707-10.322-3.556-22.336-1.894C-34.351-.232-43.83 3.313-43.509 6.018c.322 2.709 10.322 3.557 22.337 1.894C-9.157 6.25.321 2.707 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.864 209.666)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s7.762-8.865 10.338-17.657"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.283 191.446)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-2.425 8.273-7.875 19.718-7.95 19.803 0 0 8.5-6.583 11.788-18.678z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(327.706 188.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-.345-.535C-.58-.87-.897-1.393-1.348-2c-.443-.616-.964-1.381-1.606-2.2a70.71 70.71 0 00-2.141-2.761c-.792-.997-1.642-2.081-2.593-3.164-.934-1.102-1.893-2.285-2.934-3.452a239.363 239.363 0 00-3.196-3.592l-3.32-3.652-6.532-7.105c-1.017-1.144-2.056-2.214-2.976-3.274l-1.338-1.549c-.444-.493-.878-.972-1.262-1.448-.782-.95-1.507-1.821-2.14-2.614-.601-.805-1.172-1.502-1.588-2.111-.441-.599-.765-1.088-.995-1.427l-.368-.517-.385.105.176.587c.123.38.259.955.539 1.646l.44 1.155.589 1.329c.445.937.965 1.988 1.617 3.085a54.448 54.448 0 002.192 3.484 76.673 76.673 0 002.683 3.722c1.929 2.53 4.118 5.126 6.4 7.633 4.607 4.979 9.549 9.621 13.349 12.99 1.894 1.691 3.531 3.033 4.673 3.978A1937 1937 0 01-.252.311z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.44 182.996)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-.29-.415c-.195-.253-.453-.659-.818-1.122-.363-.461-.77-1.065-1.285-1.672a53.251 53.251 0 00-1.669-2.095l-1.96-2.414-2.197-2.601c-.78-.873-1.506-1.838-2.334-2.728-.748-.957-1.591-1.855-2.351-2.813l-1.169-1.41c-.395-.466-.788-.925-1.145-1.406a34.668 34.668 0 00-1.127-1.385c-.397-.445-.698-.933-1.065-1.376-.695-.911-1.428-1.766-2.018-2.638-.323-.423-.619-.847-.945-1.241-.341-.39-.613-.792-.872-1.183-.51-.785-1.056-1.49-1.544-2.129a48.704 48.704 0 00-1.151-1.72c-.319-.486-.632-.861-.821-1.126l-.317-.401-.389.09.463 1.739c.153.553.315 1.232.546 1.996l.957 2.509c.317.935.856 1.859 1.339 2.878.467 1.029 1.093 2.04 1.725 3.094.6 1.076 1.351 2.101 2.086 3.162.706 1.083 1.578 2.065 2.374 3.106.836 1.009 1.744 1.956 2.607 2.913.92.902 1.783 1.834 2.695 2.655a73.74 73.74 0 005.087 4.359A56.28 56.28 0 00-1.733-.619C-.78.013-.211.34-.211.34z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.253 149.818)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-.157-.016-.445-.014c-.284.011-.723-.007-1.24.051-.527.043-1.169.095-1.875.23-.719.11-1.517.268-2.364.5-.847.23-1.775.471-2.711.825-.935.352-1.923.732-2.898 1.219-.988.462-1.988.988-2.96 1.598-1 .562-1.936 1.275-2.894 1.948-.932.708-1.828 1.49-2.686 2.266-.43.393-.826.824-1.22 1.242-.392.42-.788.821-1.141 1.258-.701.891-1.356 1.756-1.92 2.625a35.09 35.09 0 00-1.398 2.59c-.373.845-.64 1.653-.869 2.355-.272.673-.311 1.383-.412 1.901-.096.525-.109.959-.141 1.238-.022.285-.022.439-.022.439l.361.173.766-1.309c.261-.406.497-.947.924-1.471l1.329-1.823 1.742-2.026c.647-.692 1.372-1.384 2.098-2.121.769-.695 1.572-1.404 2.395-2.114.861-.668 1.705-1.384 2.603-2.031.891-.654 1.761-1.34 2.671-1.943a60.333 60.333 0 012.666-1.773c1.748-1.127 3.435-2.088 4.886-2.902 1.465-.788 2.678-1.465 3.549-1.893A41.822 41.822 0 01.162.365z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(317.697 156.679)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-.198.019-.558.082c-.354.071-.892.146-1.539.314-.651.161-1.45.345-2.325.636-.887.273-1.886.589-2.928 1.022a36.122 36.122 0 00-3.349 1.442c-1.162.562-2.397 1.15-3.612 1.863-.618.34-1.226.716-1.841 1.101a32.83 32.83 0 00-1.845 1.202c-1.236.82-2.432 1.744-3.625 2.674-1.163.971-2.322 1.953-3.393 3.008a30.615 30.615 0 00-1.569 1.595 27.908 27.908 0 00-1.458 1.638c-.948 1.085-1.757 2.245-2.502 3.355-.767 1.091-1.382 2.213-1.896 3.275-.551 1.032-.93 2.066-1.231 2.978-.143.463-.302.875-.39 1.287l-.231 1.125c-.164.658-.142 1.236-.191 1.59a9.221 9.221 0 00-.028.563l.375.141.211-.476c.152-.305.31-.778.625-1.33.289-.564.658-1.239 1.138-1.982.223-.381.498-.764.781-1.17.278-.412.574-.839.91-1.268a39.006 39.006 0 012.228-2.721 50.527 50.527 0 012.71-2.846c1.944-1.913 4.141-3.832 6.421-5.649 4.522-3.681 9.355-6.978 13.063-9.307 1.856-1.164 3.402-2.135 4.504-2.782A1552.05 1552.05 0 00.189.352z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341.589 271.782)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-21.219 0-29.474-7.978-32.662-14.671-2.602-5.458-3.452-11.099-2.679-17.751.029-.256.064-.512.103-.767-5.246-4.45-9.011-9.954-11.272-13.846-13.5-2.748-27.249-14.713-34.247-30.455-7.485-16.839-5.364-33.602 5.819-45.99 13.195-14.615 35.007-22.997 59.848-22.997 16.881 0 33.783 3.881 47.591 10.928 12.08 6.165 19.632 16.578 21.84 30.115 1.634 10.02.042 19.931-1.731 26.839-.022 1.642-.129 3.467-.394 5.264 2.92 5.25 4.712 13.313-.101 24.384a24.304 24.304 0 012.517 4.006c1.844 3.702 2.665 8.587 2.439 14.519-.213 5.568-2.851 13.618-14.22 20.363-7.263 4.31-17.149 7.425-28.591 9.008C9.213-.353 4.416 0 0 0m0-9c4.007 0 8.39-.325 13.026-.966 20.922-2.895 34.68-11.058 35.052-20.798.115-3.03-.052-7.253-1.503-10.166-1.174-2.357-3.059-4.484-5.484-6.32 4.87-8.001 7.638-17.33 1.402-24.313 1.183-2.234 1.12-8.21 1.12-8.21 3.286-12.066 6.7-36.581-15.203-47.759-12.666-6.464-28.183-9.945-43.5-9.945-20.558 0-40.751 6.275-53.167 20.028-21.663 23.997 6.006 62.015 27.498 62.011h.01s5.886 13.324 16.117 18.648c-.947 1.741-1.555 3.553-1.769 5.408-.577 4.963-.002 8.924 1.864 12.84C-21.605-12.389-12.892-9 0-9"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZombie);
export default __webpack_public_path__ + "static/media/zombie.76f1cc4069cba1709b9406e0a47c7164.svg";
export { ForwardRef as ReactComponent };